import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import classNames from 'classnames/bind';
import queryString from 'query-string';
import * as dvr from 'utils/dvr';

import * as pages from 'pages';
import { formatPhone } from 'utils/formatString';

import ErrorPopup from './containers/ErrorPopup';
import SuccessPopup from './containers/SuccessPopup';
import DVRNoAnswerPopup from './containers/DVRNoAnswerPopup';
import DVRNavigation from './containers/DVRNavigation';
import Navigation from './components/Navigation';
import DVRBackLink from './components/DVRBackLink';
import XbrStatus from './components/XbrStatus';
import SharingEverithingBundle from './seb.jsx';
import { fetchInitialData, openPopup } from './actions';
import { IncomingInvitationService } from './containers/IncomingInvitationService';
import { redirectPageIfNeeded } from './utils.ts';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class App extends Component {
  componentDidMount() {
    this.props.actions.fetchInitialData();

    this.unlisten = this.props?.history?.listen(() => {
      if (typeof window?.flocktory?.reInit === 'function') {
        window.flocktory.reInit();
      }
    });

    // костыль для редиректа для задачи BCNC-5472
    redirectPageIfNeeded();
  }

  componentDidUpdate() {
    const { location, history, actions } = this.props;
    const { popup } = queryString.parse(location.search);

    if (popup) {
      actions.openPopup(popup);
      history.replace(location.pathname);
    }
  }

  componentWillUnmount() {
    if (this?.unlisten) {
      this.unlisten();
    }
  }

  render() {
    const {
      mainNavigation,
      ctn,
      nickname,
      isRestrictedAccess,
      loginUrl,
      location,
      history,
    } = this.props;
    if (!mainNavigation) return <div className={cx('container')} />;

    const homeLink = mainNavigation.find((i) => i.page === 'Home');
    const activeLink = mainNavigation.find((link) => ~location.pathname.indexOf(link.path));

    return (
      <main className={cx('container')}>
        <h1 className="visuallyHidden">
          Личный кабинет абонента
        </h1>

        {!dvr.guid && (
          <div className={cx('sidebar')}>
            <div className={cx('profileInfo')} aria-label="Текущий номер">
              <div className={cx('ctn')}>
                {formatPhone(ctn)}
              </div>
              {nickname && (
                <div className={cx('nickname')}>
                  {nickname}
                </div>
              )}
            </div>

            <Navigation
              links={mainNavigation}
              activeLink={activeLink || homeLink}
              history={history}
            />
          </div>
        )}

        <div className={cx('content')}>
          {dvr.guid && (
            <DVRBackLink homeLink={homeLink} activeLink={activeLink || homeLink} />
          )}

          <div className={cx('page')}>
            {isRestrictedAccess && (
              <XbrStatus loginUrl={loginUrl} />
            )}
            <IncomingInvitationService />

            <Switch>
              {mainNavigation.map((route) => (
                <Route
                  path={route.path}
                  key={`nav-route-${route.page}`}
                  render={(props) => {
                    const Page = pages[route.page];
                    return (
                      <Page
                        {...props}
                        isRestrictedAccess={isRestrictedAccess}
                      />
                    );
                  }}
                />
              ))}

              <Route
                render={() => (
                  <Redirect to={homeLink.path} />
                )}
              />
            </Switch>
          </div>

          {dvr.guid && <DVRNavigation links={mainNavigation} />}
          {dvr.guid && <DVRNoAnswerPopup />}

          <ErrorPopup />
          <SuccessPopup />
        </div>

        <SharingEverithingBundle />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.application.settings,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchInitialData,
      openPopup,
    }, dispatch),
  };
}

App.propTypes = {
  mainNavigation: PropTypes.array,
  ctn: PropTypes.string,
  nickname: PropTypes.string,
  isRestrictedAccess: PropTypes.bool,
  loginUrl: PropTypes.string,
  actions: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
